<template>
    <div>
       <v-snackbar
      v-model="snackbarVerify"
      :vertical="vertical"
      color="red"
      :timeout="10000" top
    >
      {{ text }}
      <v-btn
        color="white"
        text
        @click="snackbarVerify = false"
      >
        Close
      </v-btn>
    </v-snackbar>
        <v-container>
            <h3 class="text-center mt-3">TRANSACTION HISTORY</h3>
            <template>
                <v-data-table
                    :headers="headers"
                    :items="transactions"
                    class="elevation-1 mt-12"
                    hide-default-footer
                    :loading="loading"
                    no-data-text="YOU DO NOT HAVE RECENT TRANSACTIONS" 
                >
                <template v-slot:item.action="{ item }"> 
                    <v-btn text color="blue" v-if="item.type==='Withdrawal'">TRACK</v-btn>
                </template>
                </v-data-table>
            </template>
        </v-container>
        
    </div>
</template>
<script>
export default {
    data(){
        return{
            snackbarVerify:false,
            text: 'Your account has not been verified! Check your mail for verification link',
            vertical: true,
            headers:[
                {
                    text: 'DATE',
                    align: 'left',
                    value: 'transactionDate',
                    class: 'subtitle-2 black--text',
                },
                { text: 'TYPE', value: 'type', sortable: false, class: 'subtitle-2 black--text' },
                { text: 'AMOUNT', value: 'amountBtc', sortable: false, class: 'subtitle-2 black--text' },
                { text: 'FEE', value: 'transactionFee', sortable: false, class: 'subtitle-2 black--text' },
                { text: 'BALANCE', value: 'finalBalance',sortable: false, class: 'subtitle-2 black--text' },
                { text: '', value: 'action', sortable: false, class: 'subtitle-2 black--text' },
            ],
            // transactions:[
            //     {date:'2020-1-8 09:08:07', type:'Spend', amount:'-0.09876', fee:'-0.7654',balance:'0.985432'},
            //     {date:'2020-1-8 09:08:07', type:'Withdrawal', amount:'-0.09876', fee:'-0.7654',balance:'0.985432'}
            // ]
        }
    },
    created(){
        const userLogged= this.$store.state.auth.isUserLogged
        const userVerified = this.$store.state.auth.logindetails.isVerified
        if(userLogged===true&&userVerified===0){
            this.snackbarVerify=true
        }

        this.$store.dispatch("GetTransactions")
        .then((success)=>{
            console.log(success);
        })
        .catch((error)=>{
            console.log(error);
        });
    },
    computed:{
        
        transactions(){
            let history=  this.$store.state.wallet.Transactions
            for(let j=0; j<history.length; j++){
                history[j].transactionDate= history[j].transactionDate.slice(0, 19).replace('T', ' ');
                
            }
            return history
        }
    },
   
    
}
</script>
